import apiClient from './apiClient';

// Superadmin user-activity view (backend `activity` app).
// Every endpoint is superuser-only, enforced server-side by IsSuperUser.
const activityService = {
  live: () => apiClient.get('/v1/activity/live/'),
  hotels: (days = 7) => apiClient.get('/v1/activity/hotels/', { days }),
  hotel: (id, days = 30) => apiClient.get(`/v1/activity/hotels/${id}/`, { days }),
};

export default activityService;
